/**
 * Brands — admin reference-data hook for the product brand picker.
 *
 * Mirrors useVatCategories: plain useEffect + useState (admin does not use
 * TanStack Query), fetched on mount from GET /v1/admin/brands. Returns an empty
 * list on failure (the picker degrades to "— none —") and logs once.
 */
import { useEffect, useState } from "react";
import type { BrandWithCountDTO } from "@wmart/shared-types";
import { api } from "./api-client.js";

interface ListResponse {
  brands: BrandWithCountDTO[];
}

export interface UseBrandsResult {
  data: BrandWithCountDTO[];
  isLoading: boolean;
  isError: boolean;
}

export function useBrands(): UseBrandsResult {
  const [state, setState] = useState<UseBrandsResult>({
    data: [],
    isLoading: true,
    isError: false,
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get<ListResponse>("/v1/admin/brands")
      .then((res) => {
        if (cancelled) return;
        setState({ data: res.brands, isLoading: false, isError: false });
      })
      .catch((err) => {
        if (cancelled) return;
        console.warn({ context: "useBrands", err }, "brands_fetch_failed");
        setState({ data: [], isLoading: false, isError: true });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
